import { TDeviceType } from '@cian/ui-kit';

import { isShowFskBannerOnMapZoom } from './isShowFskBannerOnMapZoom';
import { FOfferType, getTermsValue, offerTypeFromJsonQuery } from '../../../common/packages/JsonQuery';
import { IJsonQuery } from '../../../common/packages/api-models/common/json_query';
import { isFskRegions } from '../../containers/FskBannerContainer/helpers';

interface IIsFSKBannerAvailableArgs {
  zoom: number;
  jsonQuery: IJsonQuery;
  deviceType: TDeviceType;
  parentRegionId: number | null;
  isShowWithPromoBannerOnMobile?: boolean;
}

export function isFSKBannerAvailable({
  zoom,
  jsonQuery,
  deviceType,
  parentRegionId,
  isShowWithPromoBannerOnMobile,
}: IIsFSKBannerAvailableArgs) {
  const isFskRegion = isFskRegions(getTermsValue('region')(jsonQuery), parentRegionId);
  const offerType = offerTypeFromJsonQuery(jsonQuery);
  const isDesktop = deviceType === 'desktop';

  if (!isFskRegion) {
    return false;
  }

  if (isShowWithPromoBannerOnMobile || isShowFskBannerOnMapZoom(zoom, isDesktop)) {
    // смешанная выдача, первичка
    return (offerType & FOfferType.FlatNew) !== 0;
  }

  return false;
}
